export const LAYOUT_LOADING_START = 'LAYOUT_LOADING_START'
export const LAYOUT_LOADING_STOP = 'LAYOUT_LOADING_STOP'
export const LAYOUT_TITLE_CHANGED = 'LAYOUT_TITLE_CHANGED'